import config from "../app-config";
import serverFetch from "../utils/serverFetch";

// Prayer List CRUD
export const create_new_prayer_list = async (prayer_list_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/list`,
        method: "POST",
        body: JSON.stringify(prayer_list_data)
    })
}

export const update_prayer_list_by_id = async (prayer_list_id, prayer_list_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/list/id/${prayer_list_id}`,
        method: "PUT",
        body: JSON.stringify(prayer_list_data)
    })
}

export const get_all_prayer_lists = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/list`,
        method: "GET"
    })
}

export const get_prayer_list_by_id = async (prayer_list_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/list/id/${prayer_list_id}`,
        method: "GET"
    })
}

export const delete_prayer_list_by_id = async (prayer_list_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/list/id/${prayer_list_id}`,
        method: "DELETE"
    })
}

// Prayer CRUD - Personal / Group (DG)
export const create_new_prayer = async (prayer_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/`,
        method: "POST",
        body: JSON.stringify(prayer_data)
    })
}

export const update_prayer_by_id = async (prayer_id, prayer_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/id/${prayer_id}`,
        method: "PUT",
        body: JSON.stringify(prayer_data)
    })
}

export const get_all_prayers_by_user = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/`,
        method: "GET"
    })
}

export const get_prayer_by_id = async (prayer_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/id/${prayer_id}`,
        method: "GET"
    })
}

export const delete_prayer_by_id = async (prayer_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/id/${prayer_id}`,
        method: "DELETE"
    })
}

// Interactions
export const pray_for_prayer = async (prayer_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/pray/${prayer_id}`,
        method: "POST"
    })
}

// Corporate Prayer
export const get_published_prayer = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/corporate/list`,
        method: "GET"
    })
}

// Prayer Support
export const get_user_published_prayer_by_user_id = async (user_id) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/users/prayer/id/${user_id}`,
        method: "GET"
    })
}

export const get_all_user_published_prayer = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/prayer/users/prayer/`,
        method: "GET"
    })
}
